import { render, staticRenderFns } from "./damage-assessment-prem.vue?vue&type=template&id=39111765&scoped=true"
import script from "./damage-assessment-prem.vue?vue&type=script&lang=js"
export * from "./damage-assessment-prem.vue?vue&type=script&lang=js"
import style0 from "./damage-assessment-prem.vue?vue&type=style&index=0&id=39111765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39111765",
  null
  
)

export default component.exports